import { render, staticRenderFns } from "./ShowOrderContact.vue?vue&type=template&id=20710376&scoped=true&"
import script from "./ShowOrderContact.vue?vue&type=script&lang=js&"
export * from "./ShowOrderContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20710376",
  null
  
)

export default component.exports